import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./styles.css";
import "./weekly-actions.css";
import "./fiscal.css";
import "./mobile-pwa.css";
import "./mobile-pwa-overrides.css";
import "./partners-equity.css";
import "./financial-core.css";
import "./budgets.css";
import "./notifications.css";
import "./header-notifications.css";

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    window.__ccePwaUpdate = updateSW;
    window.dispatchEvent(new CustomEvent("cce-pwa-update", { detail: updateSW }));
  },
  onRegisterError(error) {
    console.error("Falha ao registrar o modo PWA do CCE Gestão:", error);
  }
});

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
